import { createSlice } from '@reduxjs/toolkit';
const BASE_URL = import.meta.env.VITE_Backend_URL;

const initialState = {
   token :null,
   userType : null,
   isLoggedIn : false,
   user : null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
  
    login: (state, {payload}) => {
      //// console.log(payload.token)
      state.token = payload.token;
      state.userType=payload.userType
      state.isLoggedIn=true
    },
    logout: (state) => {
        state.token = null;
        state.isLoggedIn=false;
        state.user = null
    },
 
    setUser: (state, {payload}) => {
      state.user = payload; // Set the user data from the action payload
    },

  }
});


export const fetchUser = () => async (dispatch) => {
  try {
    const token = localStorage.getItem('lsh-token');
    const response = await fetch(`${BASE_URL}/users/my-info`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : undefined,
      },
    });
    if (!response.ok) {
      throw new Error('Failed to fetch user info');
    }
    const data = await response.json();
    if (data) {
      dispatch(authSlice.actions.setUser(data?.result));
    }
  } catch (e) {
    console.error("Error fetching user data:", e);
  }
};

// Action creators are generated for each case reducer function
export const {
login,
logout
} = authSlice.actions;

export default authSlice.reducer;
